import React from "react";
import { useNavigate } from "react-router-dom";
import { pageURLs } from "@/constants";
import { plural } from "@/helpers/resultsCopy";
import "./ResultsGitcha.scss";

export const gitchaNextSteps = (presence = {}) => {
  if (!presence.activeWantListings) {
    return [
      {
        key: "post",
        title: "Post a Buyer Want-Listing",
        body: "Each one you share to Gitcha.com gets a public page people can find and contact you from.",
        label: "Post",
        path: pageURLs.agentCreatewantadMainScreen,
      },
    ];
  }
  if (presence.syndicated < presence.activeWantListings) {
    const hidden = presence.activeWantListings - presence.syndicated;
    return [
      {
        key: "syndicate",
        title: `${plural(hidden, "Buyer Want-Listing is", "Buyer Want-Listings are")} visible to members only`,
        body: "Share it to Gitcha.com so the public can find it and contact you about it.",
        label: "Open My Want-Listings",
        path: pageURLs.agentMyWantAdListings,
      },
    ];
  }
  return [];
};

export const GitchaNextSteps = ({ presence }) => {
  const navigate = useNavigate();
  const steps = gitchaNextSteps(presence);
  if (!steps.length) return null;
  return (
    <section className="results-card results-gitcha__next">
      <div className="results-card__head">
        <h3 className="results-card__title">Get found more on Gitcha.com</h3>
      </div>
      {steps.map((step) => (
        <div className="results-gitcha__step" key={step.key}>
          <div>
            <p className="results-gitcha__step-title">{step.title}</p>
            <p className="results-gitcha__step-body">{step.body}</p>
          </div>
          <button type="button" className="btn btn-outline-primary" onClick={() => navigate(step.path)}>
            {step.label}
          </button>
        </div>
      ))}
    </section>
  );
};
